import { IEquipmentModel } from '../../equipmentModels.types.ts'
import { useRecoilValue } from 'recoil'
import equipmentModelsAtom from '../../equipmentModels.atom.ts'
import { useMemo } from 'react'
import { IOption } from '@/types/global.ts'
import DropdownInput from '@/shared/Inputs/DropdownInput'

interface IProps {
  value: IEquipmentModel['id']
  onChange: (modelIds: IEquipmentModel['id'][], name: string) => void
  name: string
  title?: string
}

const EquipmentModelDropdown = (props: IProps) => {
  const models = useRecoilValue(equipmentModelsAtom).items
  const options: IOption<IEquipmentModel['id']>[] = useMemo(() => {
    return models.map((m) => ({ title: m.name, value: m.id }))
  }, [models])

  return (
    <DropdownInput
      options={options as any}
      selectedOption={props.value as any}
      onSelect={props.onChange as any}
      title={props.title || 'Выберите модели'}
      name={props.name}
    />
  )
}

export default EquipmentModelDropdown
